module.exports = __webpack_public_path__ + "static/media/landing-stripe.0314c2fa.svg";